import * as echarts from "echarts";
export function setOrDef(from, f, def) {
    var v = from ? f(from) : undefined;
    return v !== undefined ? v : def;
}
export function setIfDef(from, f) {
    var v = from ? f(from) : undefined;
    return v !== undefined ? v : undefined;
}
export function registerMap(mapName, json, options) {
    echarts.registerMap(mapName, json, options);
}
// eslint-disable-next-line
var rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/ig;
export function toRGBA(color) {
    var c = color;
    var r = 0;
    var g = 0;
    var b = 0;
    var a = 0;
    if (c.startsWith("#")) {
        switch (c.length) {
            case 4:
                r = parseInt(c[1], 16) / 15.0 * 255.0;
                g = parseInt(c[2], 16) / 15.0 * 255.0;
                b = parseInt(c[3], 16) / 15.0 * 255.0;
                a = 1.0;
                break;
            case 7:
                r = parseInt(c.substr(1, 2), 16);
                g = parseInt(c.substr(3, 2), 16);
                b = parseInt(c.substr(5, 2), 16);
                a = 1.0;
                break;
            case 9:
                r = parseInt(c.substr(1, 2), 16);
                g = parseInt(c.substr(3, 2), 16);
                b = parseInt(c.substr(5, 2), 16);
                a = parseInt(c.substr(7, 2), 16) / 255.0;
                break;
        }
    }
    else {
        var m = rgbaRegex.exec(c);
        if (m) {
            r = parseInt(m[1]);
            g = parseInt(m[2]);
            b = parseInt(m[3]);
            a = m[4] ? parseInt(m[4]) : 1.0;
        }
    }
    return { r: r, g: g, b: b, a: a };
}
export function fadeColor(col, percentage) {
    return "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + col.a * percentage / 100.0 + ")";
}
//# sourceMappingURL=Helpers.js.map